import * as preact from "preact";

import * as localAPI from "localAPI";
import { type PreactPageProps } from "pages/PreactPage";
import stores from "stores/stores";
import { SignupComponent } from "views/SignupView";

interface State {
  localMode?: boolean;
}

export default class WebReaderSignInPageView extends preact.Component<
  PreactPageProps,
  State
> {
  state: State = {};

  async componentDidMount() {
    this.setState({
      localMode: await localAPI.isLocalMode(),
    });
  }

  render() {
    if (this.state.localMode === undefined) {
      return null;
    }

    if (this.state.localMode) {
      return (
        <>
          <h2 class="spacing">Sign In To Use The Web Reader</h2>

          <div class="sign-in-view-container" style="max-width: 400px">
            <div class="sign-in-view">
              <SignupComponent stores={stores} />
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <h2 class="spacing">Welcome to Readlang!</h2>

        <p>
          Open the Readlang Web Reader on any web page to translate words and
          phrases.
        </p>

        <img
          src="/content/webReaderInstructions.jpg"
          alt="1. Click the extensions icon to the right of the Chrome address bar. 2. Click the Readlang icon."
          style="max-width: 100%;"
        />

        <ol>
          <li>
            Click the extensions icon to the right of the Chrome address bar.
          </li>
          <li>
            Click Readlang Web Reader to open the web reader on the current web
            page.
          </li>
          <li>
            (Optional) Pin the Readlang Web Reader to your Chrome toolbar for
            quick access.
          </li>
        </ol>

        <p>
          Once opened, click on any word or phrase on the web page to translate
          it:
        </p>

        <img
          src="/content/webReaderTranslateDemo.jpg"
          alt="Click on any word or phrase on the web page to translate it."
          style="max-width: 100%;width: 600px;"
        />

        <p>
          <a href="/">Discover other features of Readlang</a>.
        </p>
      </>
    );
  }
}
